import { useEffect, useMemo, useState } from "react";
import { useIntl } from "react-intl";

type ProtectionFormProps = {
  isProtected: boolean;
  password: string | null;
  toggle: (isProtected: boolean) => void;
  change: (password: string) => void;
}

const ProtectionForm = ({isProtected, password, change, toggle}: ProtectionFormProps) => {
  const intl = useIntl();
  const isEdit = useMemo(() => isProtected, [isProtected]);
  const [displayField, setDisplayField] = useState(true);

  useEffect(() => {
    const havePassword = password && password.length !== 0;
    setDisplayField(isEdit && !havePassword);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isEdit]);

  return (
    <div className="mb-5">
      <div className="mb-1.5 flex gap-2 items-center">
        <input
          id="isProtected"
          type="checkbox"
          checked={isProtected}
          onChange={e => toggle(e.target.checked)}
        />
        <label htmlFor="isProtected" className="block text-shadow text-sm">
          {intl.formatMessage({ id: 'forms.protection.label' })}
        </label>
      </div>
      {
        isEdit ? (<>
          {
            displayField ? (<>
              <input id="password"
                type="password"
                className="input"
                autoComplete="off"
                onChange={e => change(e.target.value)}
              />
            </>) : (
              <button
                className="ml-5 text-sm font-semibold hover:underline"
                onClick={() => setDisplayField(true)}>
                {intl.formatMessage({ id: 'forms.protection.changePassword' })}
              </button>
            )
          }
        </>) : <></>
      }
    </div>
  )
}

export default ProtectionForm;
